import api from '.';

export function listar({ start = 0, size = 10, filters = '[]', filtersMode = '{}', globalFilter = '', sorting = '[]' } = {}) {
    return api.get('/fiscalPerfil/listar', {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
        },
    });
}

export function consultar(uuid) {
    return api.get(`/fiscalPerfil/edit/${uuid}`);
}

export function cadastrar(dados) {
    return api.post('/fiscalPerfil/cadastrar', dados);
}

export function editar(uuid, dados) {
    return api.put(`/fiscalPerfil/editar/${uuid}`, dados);
}

export function excluir(uuid) {
    return api.delete(`/fiscalPerfil/delete/${uuid}`);
}

export function cadastrarRegra(perfilUuid, dados) {
    return api.post(`/fiscalPerfil/${perfilUuid}/regras/cadastrar`, dados);
}

export function editarRegra(perfilUuid, regraUuid, dados) {
    return api.put(`/fiscalPerfil/${perfilUuid}/regras/${regraUuid}`, dados);
}

export function excluirRegra(perfilUuid, regraUuid) {
    return api.delete(`/fiscalPerfil/${perfilUuid}/regras/${regraUuid}`);
}
